import { APIResultCount } from 'src/constant'
import { IScheduledTask } from 'src/generated-types/scheduledTask'
import { resourceQueryKeys } from 'src/query-keys'
import { IResource } from '../generated-types/resource'
import { queryClient } from '../query-client'
import { apiConsts } from './apiConsts'
import { IPaginatedResult } from './paginated-result'
import { useDelete, useGet, usePost, usePut } from './reactQuery'

const mainComponentBaseURL = (customerId: EntityId) => `customers/${customerId}/resource`

export const resourceEndpoints = {
  baseURL(customerId) {
    return `${mainComponentBaseURL(customerId)}`
  },
  singleResources(customerId, id) {
    return `${mainComponentBaseURL(customerId)}/${id}`
  },
  unAssignedResources(customerId) {
    return `${mainComponentBaseURL(customerId)}/unAssignedResources`
  },
  getRelatedTasks(customerId: EntityId, id: EntityId) {
    return `${mainComponentBaseURL(customerId)}/${id}/tasks`
  },
}

export const invalidateTaskResourceCache = {
  getAllResources(customerId) {
    queryClient.invalidateQueries(resourceEndpoints.baseURL(customerId))
  },
  getRelatedTasks(customerId: EntityId, id?: EntityId) {
    queryClient.invalidateQueries(resourceQueryKeys.GET_RELATED_TASKS(customerId, id))
  },
  getAllUnAssignedResources(customerId: EntityId) {
    queryClient.invalidateQueries(resourceEndpoints.unAssignedResources(customerId))
  },
}

export const useGetAllResources = (
  customerId: number,
  page: number = apiConsts.Page,
  pageSize: number = APIResultCount.Max,
  onlyWithWorkOrders?: boolean,
) => useGet<IPaginatedResult<IResource>>(resourceEndpoints.baseURL(customerId), { page, pageSize, onlyWithWorkOrders })

export const useGetAllUnAssignedResources = (
  customerId: number,
  page: number = apiConsts.Page,
  pageSize: number = APIResultCount.Max,
) => useGet<IPaginatedResult<IResource>>(resourceEndpoints.unAssignedResources(customerId), { page, pageSize })

export const useGetRelatedTasks = (customerId: number, id: number) =>
  useGet<IPaginatedResult<IScheduledTask>>(
    resourceEndpoints.getRelatedTasks(customerId, id),
    { page: apiConsts.Page, pageSize: apiConsts.Max },
    {
      queryKey: resourceQueryKeys.GET_RELATED_TASKS(customerId, id),
    },
  )

export const useAddResource = (customerId: number) => usePost(resourceEndpoints.baseURL(customerId))

export const useUpdateResource = (customerId: number, id: number) =>
  usePut(resourceEndpoints.singleResources(customerId, id))

export const useDeleteResource = (customerId: number) => useDelete(resourceEndpoints.baseURL(customerId))
